import React, { Component } from 'react'
import propTypes from 'prop-types'
import {
  GenerateProposalDropdown,
  Progress,
  productUtils,
  formatCurrency,
  Card,
  Formik,
  Form,
  Row,
  Col,
  i18n,
  SpacedCol,
  FormikEffect,
  FormikButton,
  FormikInput,
} from '@tools/wr-catalog-base'
import FiltersDropdown from '@components/FiltersDropdown'
import SortableCart from './SortableCart/cart'
import { validationSchema } from './consts'

import { ProductsCart, CartHeader, CartTotal, ModalDescription } from './styles'

export default class Cart extends Component {
  static propTypes = {
    initialValues: propTypes.object,
  }

  static defaultProps = {
    initialValues: {
      company: '',
      name: '',
      email: '',
      desiredStartDate: '',
    },
  }

  submitType = null

  modalProps = {
    showClose: false,
    body: (
      <>
        <ModalDescription>We are generating your proposal</ModalDescription>
        <Progress />
      </>
    ),
  }

  handleSubmit = (values, { setSubmitting }) => {
    this.props.submitProposal({
      [this.submitType]: true,
      formValues: values,
    })
    this.props.context.actions.openModal({ ...this.modalProps })

    setSubmitting(false)
  }

  getTotalPrice = () => {
    const { cart } = this.props.context.state
    let totalPrice = 0
    const withoutDividing = true

    Object.keys(cart).forEach((key) => {
      const product = cart[key]

      totalPrice += productUtils.getPrice(product, withoutDividing)
    })

    return totalPrice
  }

  getPointTotalPrice = () => {
    const { cart } = this.props.context.state
    let totalPrice = 0
    const withoutDividing = true
    const credits = true

    Object.keys(cart).forEach((key) => {
      const product = cart[key]

      totalPrice += parseInt(productUtils.getPrice(product, withoutDividing, credits))
    })

    return totalPrice
  }

  render() {
    const { context, initialValues, showVMSButton } = this.props
    const { cart, pointSystem } = context.state
    const price = pointSystem ? this.getPointTotalPrice() : formatCurrency(this.getTotalPrice())
    const initialCompany = initialValues.company || context.state.cartCompany || ''

    return (
      <ProductsCart className="product-details-cart">
        <Card>
          {({ Header, Body, Footer }) => (
            <>
              <Header divider>
                <CartHeader>
                  <Formik
                    onSubmit={this.handleSubmit}
                    initialValues={{ ...initialValues, company: initialCompany }}
                    validationSchema={validationSchema}
                  >
                    {(formikProps) => (
                      <Form noValidate>
                        <FormikEffect
                          onChange={(prevFormik, formik) => {
                            if (formik.values.company !== prevFormik.values.company) {
                              context.state.cartCompany = formik.values.company
                            }
                          }}
                        />
                        <Row>
                          <Col xs={12}>
                            <Row middle="xs">
                              <Col xs>
                                <span>
                                  {pointSystem
                                    ? i18n('proposalGeneration.form.totalPriceInPoints')
                                    : i18n('proposalGeneration.form.totalPrice')}
                                  :
                                </span>
                                <CartTotal>{price}</CartTotal>
                              </Col>
                              <Col style={{ zIndex: 100 }}>
                                <FiltersDropdown
                                  buttonProps={{
                                    'data-track': 'click',
                                    'data-name': 'main-page-control',
                                    'data-title': 'Choose Region',
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <SpacedCol xs={12}>
                            <FormikInput
                              name="company"
                              type="text"
                              placeholder={i18n('proposalGeneration.form.company')}
                              fullWidth
                            />
                          </SpacedCol>
                          <SpacedCol xs={12}>
                            <GenerateProposalDropdown
                              theme={context.theme.components.dropdown.color}
                              options={{
                                asPdf: !window.wrBox || process.env.NODE_ENV === 'development',
                                asDoc: false,
                                asDraft: false,
                              }}
                              onChange={(value) => {
                                this.submitType = value
                                formikProps.submitForm()
                              }}
                            />
                          </SpacedCol>
                          {showVMSButton && (
                            <SpacedCol xs={12}>
                              <FormikButton fullWidth primary type="button" disabled>
                                {i18n('proposalGeneration.sendToVms')}
                              </FormikButton>
                            </SpacedCol>
                          )}
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </CartHeader>
              </Header>
              <Body unpadded>
                <SortableCart cart={cart} />
              </Body>
            </>
          )}
        </Card>
      </ProductsCart>
    )
  }
}
